export default "__VITE_ASSET__55add736__"